<template>
	<div class="m-option-filters">
        <ul class="js-option-filter-buttons" ref="list">
        	<slot></slot>
        </ul>
    </div>
</template>

<script>

    export default {
        name: 'option-filters',
        mounted: function() {
            this.init()
        },
        methods: {
        	init() {
        		const buttonList = this.$refs.list.querySelectorAll("li");
                const buttonListATag =this.$refs.list.querySelectorAll("li a");

                buttonList.forEach(clickElement => clickElement.addEventListener('click', selectButton));
                buttonListATag.forEach(clickElement => clickElement.addEventListener('click', selectButton));

                function selectButton(e) {
	        		buttonList.forEach(function(element) {
					    element.classList.remove("m-option-filters--active");
					});
	        		e.currentTarget.classList.add('m-option-filters--active');
	        	}
        	},
        }
    }

</script>


// WEBPACK FOOTER //
// OptionFilters.vue?1eb50e74